import apiConfig from "../../apiConfig";

export const getDonationBandDetails = async (at, donationBandId) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/DONATIONS_BANDS/Get_Donation_Band_Details",
		{ Donation_Band_Id: donationBandId },
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	return response;
};
